export default function initBreadcrumbs() {
    const { origin, pathname } = window.location;
    const itemListElement = [];
    let position = 1;

    document.querySelectorAll('#content .breadcrumbs .breadcrumb li a[href]').forEach(item => {
        itemListElement.push({
            '@type': 'ListItem',
            position,
            name: item.textContent.trim(),
            item: item.href,
        });
        position++;
    });

    document.querySelectorAll('#content .breadcrumbs .breadcrumb li.active').forEach(item => {
        itemListElement.push({
            '@type': 'ListItem',
            position,
            name: item.textContent.trim(),
            item: `${origin}${pathname}`,
        });
        position++;
    });

    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
    });
    document.head.appendChild(script);
}
